<template>
    <div class="danger-modal-pp">
        <b-modal
            ref="warning-modal-pp-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <DangerMsgModal :msg="getMesage" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="hideModal()">Fechar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'

const SESSION_EXPIRED = 'Sua sessão expirou!'

export default {
    name: 'DangerModalPP',
    components: { DangerMsgModal },
    props: {
        message: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            backLogin: false,
            isAdmin: false
        }
    },
    methods: {
        showModal() {
            this.$refs['warning-modal-pp-ref'].show()
        },
        hideModal() {
            this.$refs['warning-modal-pp-ref'].hide()

            if (
                this.getMesage === SESSION_EXPIRED &&
                (localStorage.getItem('usuario') || localStorage.getItem('authentication-admin'))
            ) {
                this.isAdmin = Object.keys(localStorage).includes('authentication-admin')
                this.clearLocalStorage()
            }
        },
        clearLocalStorage() {
            localStorage.clear()
            if (this.isAdmin) {
                this.$router.push({ name: 'LoginAdminForm' })
            } else {
                this.$router.push({ name: 'LoginForm' })
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getMesage() {
            if (
                this.message === 'Unauthenticated.' &&
                (localStorage.getItem('usuario') || localStorage.getItem('authentication-admin'))
            ) {
                return SESSION_EXPIRED
            }
            return this.message
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/ui/modal/danger-modal-pp/DangerModalPP.vue